module.exports = __webpack_public_path__ + "static/media/mr-clean-secondary.7ee794af.svg";